import { buildApiUrl, ADMIN_ENDPOINTS } from '@/project/configs/api.js'

export default {
  url(payload) {
    if (payload?.operation === 'update' && payload?.id) {
      return buildApiUrl(ADMIN_ENDPOINTS.REWARD_MILESTONE_UPDATE, { pathParams: { id: payload.id } })
    }
    return buildApiUrl(ADMIN_ENDPOINTS.REWARD_MILESTONE_CREATE)
  },

  method() {
    return 'POST'
  },

  format(payload) {
    const { id, operation, ...rest } = payload || {}
    return rest
  },

  parse(raw = {}) {
    if (raw?.statusCode !== 200 && raw?.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        success: false,
        message: raw?.message || 'Erreur lors de la sauvegarde du jalon',
      }
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Jalon sauvegardé avec succès',
      data: raw?.data,
    }
  },
}
